(() => {
  'use strict';

  const revealObservers = new WeakMap();

  function initReveal(root = document) {
    const items = root.querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.01
    });

    items.forEach((item) => observer.observe(item));

    if (root !== document) {
      revealObservers.set(root, observer);
    }
  }

  function init(root = document) {
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const observer = revealObservers.get(event.target);
    if (observer) {
      observer.disconnect();
      revealObservers.delete(event.target);
    }
  });
})();
